module.exports = __webpack_public_path__ + "img/sideface-bus.95c6b813.png";